<template>
  <div class="full-screen">
    <div id="scroll-div-category" class="main scroll-list" style="z-index: 1; height: calc(100% - 50px);">
      <div>
        <ul class="serchlist">
          <li>
            <span v-for="(item, index) in category.publishStatusList" :key="item.code"
                  :class="{ active: getPublishActive === item.code}"
                  @click="changePublishStatus(item.code)">{{ item.desc }}</span>
          </li>
          <li>
            <span v-for="(item, index) in category.categoryList" :key="item.id"
                  :class="{ active: getCategoryActive === item.id }"
                  @click="changeCategory(item.id)">{{ item.name }}</span>
          </li>
        </ul>
      </div>
<!--      <div class="title row">-->
<!--        <i></i>-->
<!--        <span class="flex cc">共找到{{totalItem}}部</span>-->
<!--      </div>-->
      <books-large :books="books" :show-title="false"></books-large>
      <loading ref="loading" scroll-div="scroll-div-category" :is-loading="isLoading" :is-no-more-data="isNoMoreData"
               @get-books="getBooks(currentPage + 1)"></loading>
    </div>
    <!-- <a id="categoryReportUrl" class="fixed-ts" style="z-index: 10"><span>投诉</span></a> -->
    <bottom></bottom>
  </div>
</template>

<script>
import BooksLarge from '@/components/share/books-large'
import Bottom from '@/components/layer1/bottomIndex'
import Loading from "../../components/share/loading";

import listService from "../../services/listService";
import userService from "../../services/userService";
// import {getReportUrl} from "../../services/urlService";

export default {
  name: "category",
  data() {
    return {
      componentName: '',
      category: {
        publishStatusList: [],
        categoryList: []
      },
      selected: {
        category: '0',
        publish: 'all'
      },
      isLoading: false,
      isNoMoreData: false,
      currentPage: 1,
      totalItem: 0,
      books: []
    }
  },
  computed: {
    getPublishActive() {
      return this.selected.publish
    },
    getCategoryActive() {
      return this.selected.category
    }
  },
  methods: {
    getCategory() {
      listService.getCategory()
        .then(res => {
          let c = {};
          c.publishStatusList = [{code: 'all', desc: '全部'}, ...res.data.publishStatusList];
          c.categoryList = [{id: '0', name: '全部'}, ...res.data.categoryList];
          this.category = c
        })
    },
    changePublishStatus(code) {
      this.selected.publish = code;
      this.getBooks(1);
    },
    changeCategory(id) {
      this.selected.category = id;
      this.getBooks(1);
    },
    getBooks(target) {
      this.currentPage = target;
      this.isLoading = true;
      this.isNoMoreData = false;
      if (target === 1) {
        this.books = [];
      }
      listService.getBooks(this.selected.category, target, this.selected.publish)
        .then(res => {
          this.isLoading = false;
          if (res.result) {
            if (res.data.totalPage === 0) {
              this.books = [];
            } else if (this.currentPage === 1) {
              this.books = res.data.bookList;
            } else if (this.currentPage > 1 && this.currentPage <= res.data.totalPage) {
              this.books.push(...res.data.bookList);
            }
            if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
              this.isNoMoreData = true;

              //alert('getBooks end '+this.isNoMoreData)
            }
            this.totalItem = res.data.totalItem;
            setTimeout(() => {
              this.$refs['loading'].scrollFunction();
            }, 100)
          }
        })
    }
  },
  components: {
    'books-large': BooksLarge,
    bottom: Bottom,
    loading: Loading
  },
  mounted() {
    this.userInfo = userService.getLocalUserInfo();
    // if (this.userInfo == null) {
    //   document.getElementById("categoryReportUrl").href = getReportUrl(null);
    // } else {
    //   document.getElementById("categoryReportUrl").href = getReportUrl(this.userInfo.account);
    // }
    this.componentName = this.$route.name;
    console.log(this.componentName, this.$store.state.pageState[this.componentName]);
    if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
      Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
      setTimeout(() => {
        let scrollDiv = document.getElementById('scroll-div-category');
        console.log(this.$store.state.pageState[this.$route.name].top);
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
      }, 0);
    } else {
      this.getCategory();
      this.getBooks(1);
    }
    this.$router.isBack = true;
  },
  beforeDestroy() {
    let scrollDiv = document.getElementById('scroll-div-category');
    let state = {};
    state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
    this.$store.commit('saveState', state);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer1/category.vue